import { render, staticRenderFns } from "./occupation.vue?vue&type=template&id=42d0aee6&scoped=true&"
import script from "./occupation.vue?vue&type=script&lang=js&"
export * from "./occupation.vue?vue&type=script&lang=js&"
import style0 from "./occupation.vue?vue&type=style&index=0&id=42d0aee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d0aee6",
  null
  
)

export default component.exports